<template>
  <div class="panel">
    <div class="panel-head">
      <div>
        <div class="panel-title">{{ $t('chi99') }}</div>
        <div class="subtitle">{{ $t('chi100') }}</div>
      </div>
      <span class="badge tag">{{ $t('chi101') }}</span>
    </div>
    <div style="overflow: auto">
      <el-table :data="logList" style="width: 100%" size="small" :empty-text="$t('chi9')">
        <el-table-column prop="name" :label="$t('chi90')" min-width="120"></el-table-column>
        <el-table-column prop="sn" :label="$t('chi91')" width="150"></el-table-column>
        <el-table-column prop="group_name" :label="$t('chi92')" min-width="100">
          <template slot-scope="{ row }">{{ row.group_name || '—' }}</template>
        </el-table-column>
        <el-table-column :label="$t('chi101')" width="160">
          <template slot-scope="{ row }">
            <span class="badge" :class="row.event_type === 1 ? 'online' : 'offline'">
              {{ row.event_type === 1 ? $t('chi102') : $t('chi103') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column :label="$t('chi104')" width="160">
          <template slot-scope="{ row }">{{ formatTime(row.event_time) }}</template>
        </el-table-column>
        <el-table-column :label="$t('chi105')" width="140">
          <template slot-scope="{ row }">{{ durationText(row.duration) }}</template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer-actions">
      <el-pagination
        small
        layout="prev, pager, next"
        :total="logTotal"
        :page-size="limit"
        :current-page.sync="page"
        @current-change="onPage"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { dateFormat, timeFormatting } from "@/assets/scripts/dateFormatting.js";
import { splitDuration } from "./statUtils.js";

export default {
  name: "BootLogTable",
  props: {
    // getDeviceBootLog 返回的 log_list
    logList: { type: Array, default: () => [] },
    logTotal: { type: Number, default: 0 },
    limit: { type: Number, default: 10 },
  },
  data() {
    return {
      page: 1,
    };
  },
  methods: {
    formatTime(ts) {
      const d = new Date(ts * 1000);
      return `${dateFormat(d)} ${timeFormatting(d)}`;
    },
    durationText(sec) {
      if (!sec || sec <= 0) return "—";
      const { h, m } = splitDuration(sec);
      if (h <= 0) return `${m} ${this.$t("chi107")}`;
      return `${h} ${this.$t("chi106")} ${m} ${this.$t("chi107")}`;
    },
    onPage(page) {
      this.$emit("page-change", page);
    },
  },
};
</script>

<style lang="scss" scoped>
.panel {
  background: #fff;
  border: 1px solid #dcecf4;
  border-radius: 15px;
  box-shadow: 0 8px 28px rgba(31, 142, 190, 0.08);
  overflow: hidden;
}
.panel-head {
  padding: 16px 18px;
  border-bottom: 1px solid #dcecf4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.panel-title {
  font-weight: 800;
  font-size: 16px;
  color: #314356;
}
.subtitle {
  margin-top: 5px;
  color: #7f93a6;
  font-size: 14px;
}
.badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 5px 9px;
  font-size: 12px;
  font-weight: 700;
}
.online {
  background: #e9f9f2;
  color: #2faa77;
}
.offline {
  background: #fff0f0;
  color: #e85a5a;
}
.tag {
  background: #eef8ff;
  color: #279ee7;
}
.empty {
  text-align: center;
  color: #909399;
  font-size: 14px;
  padding: 24px 0;
}
.footer-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 12px 16px;
}
</style>
